<template>
  <div>
    <fb-signin-button
      v-if="!disabled"
      :params="fbSignInParams"
      @success="onSignInSuccess"
      @error="onSignInError"
    >
      <div class="facebook-login-btn">
        <img src="/static/svg/icon-text-facebook.svg">
        {{ text }}
      </div>
    </fb-signin-button>
    <div
      v-else
      class="facebook-login-btn facebook-login-btn--disabled"
    >
      <img src="/static/svg/icon-text-facebook.svg">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacebookLoginButton',
  props: {
    text: {
      type: String,
      default: 'Login with Facebook'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fbSignInParams: {
        scope: 'email',
        return_scopes: true
      }
    }
  },
  methods: {
    onSignInSuccess (params) {
      if (!this.disabled) {
        this.$emit('onSignInSuccess', params)
      }
    },
    onSignInError (error) {
      if (!this.disabled) {
        this.$emit('onSignInError', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.facebook-login-btn {
  background-color: #3C5A99;
  color: #fff;
  padding: 12px 19px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
  text-align: left;

  &--disabled {
    background-color: #b3b3b3;
    cursor: not-allowed;
  }
}
.facebook-login-btn img {
  vertical-align: middle;
  margin-right: 33px;
}
</style>



// WEBPACK FOOTER //
// src/components/FacebookLoginButton.vue